import { createContext, useContext, useState } from "react";
import { translations } from "../i18n/translations";

const LangContext = createContext(null);

export const LanguageProvider = ({ children }) => {
  const [lang, setLangState] = useState(() => localStorage.getItem("apex_lang") || "es");
  const setLang = (l) => {
    setLangState(l);
    localStorage.setItem("apex_lang", l);
  };
  return (
    <LangContext.Provider value={{ lang, setLang, t: translations[lang] }}>
      {children}
    </LangContext.Provider>
  );
};

export const useLang = () => useContext(LangContext);
